
import { granjaApi } from "../../api";
import Swal from "sweetalert2";
import { useOrdenesPagoStore } from "../../store";






export const startOrdenCompraXID = async(id) => {
    try {
        const { data } = await granjaApi.get(`/ordencompra/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}





export const startListadoOrdenesCompra = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/ordencompra/todos', { params });
        useOrdenesPagoStore.setState({ totalOrdenesPago: data.total });
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingOrdenCompra = async(items) => {
    try {
        await granjaApi.post('/ordencompra/new', items);
        Swal.fire('Exitoso', 'Orden de Compra Creada', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 




export const startAprobarXRol = async(id) => {
    try {
        await granjaApi.get(`/ordencompra/aprobar/user/${id}`);
        Swal.fire('Exitoso', 'Orden aprobada para compra', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 






// export const startProductosTodos = async(nombre) => {
//     try {
//         const params = new URLSearchParams();
//         params.append('nombre',  nombre);
//         const { data } = await granjaApi.get(`/producto/todos`, { params });
//         return data.data;
//     } catch (error) {
//         console.log(error)
//         Swal.fire('Error', error.response.data.msg, 'error');
//     }
// }




// export const startListadoItemsCompra = async({ page=0, termino='' }) => {
//     try {
//         const params = new URLSearchParams();
//         params.append('page',  page.toString());
//         params.append('termino',  termino);

//         const { data } = await granjaApi.get('/itemscompra/todos', { params });
//         useItemspagoStore.setState({ totalItemsPago: data.total });
//         return data.data;

//     } catch (error) {
//         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
//         throw new Error(errores);
//     }
// }






    



// export const startDeleteProducto = async(id) => {
//     try {
//         const { data } = await granjaApi.delete(`/producto/${id}`);
//         Swal.fire('Exitoso', 'Producto Eliminado', 'success');
//         return data.data;
//     } catch (error) {
//         const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
//         Swal.fire('Error', msg, 'error');
//         return false;
//     }
// }